// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings__actions--save[data-v-da2f8dc6]{margin-top:30px;height:44px}.small-sub[data-v-da2f8dc6]{margin-top:16px;font-size:12px!important;font-weight:400!important;color:#7c8b91!important}.api-error[data-v-da2f8dc6]{margin:30px 0;font-size:14px;font-weight:400;color:#ff5b61}", ""]);
// Exports
module.exports = exports;
